import { CSSProperties } from 'react';
import { Flex, TagGroup, Truncate, Text, Box, DataList, DataItem } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { EventLabelPill } from '../../common/components/event-label-pill';
import { Tooltip } from '~/common/components/tooltip';

const customEventLabelStyling: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 6px',
    borderRadius: '2px',
    cursor: 'default',
    userSelect: 'none',
    fontSize: '14px',
    lineHeight: 'none',
};

export const EventsSummary = observer(function EventsSummary({
    label,
    eventNumbers,
    unselectedEventNumbers,
}: {
    label: string;
    eventNumbers: string[];
    unselectedEventNumbers?: string[];
}): React.ReactElement {
    return (
        <DataList>
            <DataItem
                dataKey={<Box style={{ whiteSpace: 'nowrap' }}>{label}</Box>}
                style={{ alignItems: 'center' }}
            >
                <Flex flexWrap="wrap" style={{ minWidth: 0 }}>
                    <Truncate
                        style={{ alignItems: 'center' }}
                        renderCounter={(truncatedCount) => {
                            return (
                                <Tooltip
                                    overlay={
                                        <TagGroup>
                                            {eventNumbers
                                                .slice(-1 * truncatedCount)
                                                .map((eventNumber) => {
                                                    return (
                                                        <EventLabelPill
                                                            key={eventNumber}
                                                            name={eventNumber}
                                                            style={customEventLabelStyling}
                                                            variant={
                                                                unselectedEventNumbers?.includes(
                                                                    eventNumber
                                                                )
                                                                    ? 'ghost'
                                                                    : 'default'
                                                            }
                                                        />
                                                    );
                                                })}
                                        </TagGroup>
                                    }
                                >
                                    <Text
                                        style={{
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                        }}
                                        fontSize="sm"
                                    >
                                        + {truncatedCount}
                                    </Text>
                                </Tooltip>
                            );
                        }}
                    >
                        {eventNumbers.map((eventNumber, i) => {
                            return (
                                <EventLabelPill
                                    key={i}
                                    name={eventNumber}
                                    style={customEventLabelStyling}
                                    variant={
                                        unselectedEventNumbers?.includes(eventNumber)
                                            ? 'ghost'
                                            : 'default'
                                    }
                                />
                            );
                        })}
                    </Truncate>
                </Flex>
            </DataItem>
        </DataList>
    );
});
